import { Component, ChangeDetectionStrategy, Inject, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';

import { Subject, BehaviorSubject } from 'rxjs';

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent
} from 'angular-calendar';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Calendar, CalendarForm } from '../../calendar/model/model.class';
import { Router } from '@angular/router';
import { CalendarService } from '../../calendar/calendar.service';
import { MatSnackBar, MatDatepickerInputEvent } from '@angular/material';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Option } from '../../shared/model/model.class';
import { HttpClient } from '@angular/common/http';
import { APIURL } from '../../app-routing.module';
import { Theme } from '../../shared/service/AutoTheme';

const colors: any = {
  green: {
    primary: '#0ca12e',
    secondary: '#0ca12e'
  },
  yellow: {
    primary: '#D88E08',
    secondary: '#D88E08'
  },
  blue: {
    primary: '#3a87ad',
    secondary: '#3a87ad'
  }
};

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent extends AppComponentClass<Calendar, CalendarForm> {

  public form: FormGroup;
  events: CalendarEvent[] = [];
  list1 = false;
  loading = true;
  protected calstatus = new BehaviorSubject<boolean>(false);
  public calander = this.calstatus.asObservable();

  public cal_list: Option[];
  public cal_id: string = "";
  public startlimit: any;
  public endlimit: any;
  public address: string;

  //constructor(private modal: NgbModal) {}
  constructor(public edata: CalendarService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, private modal: NgbModal, protected http: HttpClient, public theme: Theme) {
    super(edata, router, fb, msg);
    this.theme.showMenu(true);
    this.theme.ChangeEvent(0);
  }

  // onAddevent()
  // {
  //  // this.step++;
  //   this.cdata.calendar_id=this.cal_id;
  // }

  actions: CalendarEventAction[] = [

  ];


  ngOnInit() {
    //current page track
    this.loading = true;


    sessionStorage.setItem('pagetrack', 'calendar');
    this.address = sessionStorage.getItem('current_address');
    //this.address= JSON.parse(sessionStorage.getItem("edit"));
    console.log(this.address);
    this.edata.getCalandarService({ leadaddress: this.address }).subscribe(res => {
      console.log("calendar service");
      console.log(res);
      if (res != null) {
        this.cdata = new CalendarForm(res[0]);
        this.events = this.cdata.MakeEvent(res, this.actions, colors.green);
        console.log("calendar event");
        console.log(this.events);
        this.edata.getCalendarList().subscribe(res1 => {
          console.log("calendar list");
          console.log(res1);
          this.cal_list = res1;

          this.edata.getAuthToken().subscribe(rs => {
            console.log("Auth token my calendar");
            console.log(rs);
            if (rs != null) {
              if (rs[0].access_token && rs[0].status == 3) {
                this.form = this.cdata.makeform(this.fb);
                console.log("calling now for calendar_id");
                this.calstatus.next(true);
                //this.calenstatus=true;
                console.log(rs);
                this.cdata.calendar_id = rs[0].calendar_id;
                this.form.controls['calendar_id'].setValue(rs[0].calendar_id);
                this.cdata.startlimit = rs[0].startlimit;
                this.form.controls['startlimit'].setValue(rs[0].startlimit);
                this.startlimit = new FormControl((new Date(this.cdata.startlimit)).toISOString());
                this.cdata.endlimit = rs[0].endlimit;
                this.form.controls['endlimit'].setValue(rs[0].endlimit);
                this.endlimit = new FormControl((new Date(this.cdata.endlimit)).toISOString());
                this.cal_id = rs[0].calendar_id;
                this.loading = false;
              }
              else {
                this.router.navigate(['/calendar/googlelogin']);
              }
            }
            else {
              //this.cdata.calendar_id="";
              this.router.navigate(['/calendar/googlelogin']);
            }


          });

        }, err => {
          console.log(err);
          this.router.navigate(['/calendar/googlelogin']);
        });


      }
      else {
        this.router.navigate(['/calendar/googlelogin']);
      }

      console.log("working");

    });
  }

  // onCalendarChange(event:any)
  // {
  //   if(confirm("Are you sure to change calendar type?"))
  //   {
  //     console.log(event);
  //     this.http.put<any>(APIURL+"custom/updatecalid", {"data":{calendar_id: event.value}}, { headers: {"Content-Type": "application/json"}, params: {calendar_id: event.value}}).subscribe(res=>{
  //       console.log(res);
  //       this.router.navigate ( [ '/calendar/googlelogin' ] );
  //     });
  //   }
  //   else
  //   {
  //     window.location.reload();
  //   }
  // }

  onStartChange(e: MatDatepickerInputEvent<Date>) {
    if (e.value) {
      var tmp = new Date(e.value);
      var mth = "";
      var day = "";
      if (tmp.getDate() < 9)
        day = "0" + tmp.getDate();
      else
        day = tmp.getDate().toString();
      if (tmp.getMonth() < 9)
        mth = "0" + (tmp.getMonth() + 1);
      else
        mth = (tmp.getMonth() + 1).toString();
      this.cdata.startlimit = tmp.getFullYear() + "-" + mth + "-" + day;
      console.log(e);
    }
    else {
      alert("Please select any date");
    }
  }

  onEndChange(e: MatDatepickerInputEvent<Date>) {
    if (e.value) {
      var tmp = new Date(e.value);
      var mth = "";
      var day = "";
      if (tmp.getDate() < 9)
        day = "0" + tmp.getDate();
      else
        day = tmp.getDate().toString();
      if (tmp.getMonth() < 9)
        mth = "0" + (tmp.getMonth() + 1);
      else
        mth = (tmp.getMonth() + 1).toString();
      this.cdata.endlimit = tmp.getFullYear() + "-" + mth + "-" + day;
      console.log(e);
    }
    else {
      alert("Please select any date");
    }
  }



  onSubmit() {
    console.log("trying to submit form");
    console.log(this.cdata);
    console.log(this.cdata.startlimit);
    console.log(this.cdata.endlimit);

    var tmp = new Date(this.cdata.startlimit);
    var mth = "";
    var day = "";
    if (tmp.getDate() < 9)
      day = "0" + tmp.getDate();
    else
      day = tmp.getDate().toString();
    if (tmp.getMonth() < 9)
      mth = "0" + (tmp.getMonth() + 1);
    else
      mth = (tmp.getMonth() + 1).toString();
    this.cdata.startlimit = tmp.getFullYear() + "-" + mth + "-" + day;
    console.log(this.cdata.startlimit);

    var tmp = new Date(this.cdata.endlimit);
    var mth = "";
    var day = "";
    if (tmp.getDate() < 9)
      day = "0" + tmp.getDate();
    else
      day = tmp.getDate().toString();
    if (tmp.getMonth() < 9)
      mth = "0" + (tmp.getMonth() + 1);
    else
      mth = (tmp.getMonth() + 1).toString();
    this.cdata.endlimit = tmp.getFullYear() + "-" + mth + "-" + day;
    console.log(this.cdata.endlimit);

    if (this.cdata.startlimit == 'NaN-NaN-NaN' || this.cdata.endlimit == 'NaN-NaN-NaN') {
      alert("Please select any date");
    }
    else {
      if (confirm("Are you sure you want to re-sync your calendar?")) {
        this.edata.updateMyCalender({ calendar_id: this.form.get("calendar_id").value, startlimit: this.cdata.startlimit, endlimit: this.cdata.endlimit, status: 2 }, "updatecalid").subscribe(res => {
          console.log(res);
          // this.router.navigate(['/calendar/googlelogin']);
        });
      }
    }
  }

  deleteCalendar() {
    if (confirm("Are you sure you want to delete current calendar access?")) {
      this.edata.updateMyCalender({ status: 4 }, "deletecal").subscribe(res => {
        // this.http.put<any>(APIURL+"custom/deletecal", {"data":{status: 4}}, { headers: {"Content-Type": "application/json"}, params: {calstatus: '4'}}).subscribe(res=>{
        console.log(res);
        // this.router.navigate(['/calendar/googlelogin']);
      });
    }
  }

  @ViewChild('modalContent') modalContent: TemplateRef<any>;

  view: string = 'week';

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();


  loadNextEvents(e: Date) {
    this.activeDayIsOpen = false;
    //console.log("date changed");
    var currentdate = e;
    // console.log("currentdate");
    // console.log(currentdate);
    var today = new Date();
    var nextWeek = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);
    // console.log("today");
    // console.log(today);
    // console.log("nextWeek");
    // console.log(nextWeek);
    // console.log("currentdate.getTime()");
    // console.log(currentdate.getTime());
    // console.log("nextWeek.getTime()");
    // console.log(nextWeek.getTime());
    if (currentdate.getTime() >= nextWeek.getTime()) {
      //current page track
      this.loading = true;
      this.calstatus.next(false);
      sessionStorage.setItem('pagetrack', 'calendar');
      this.address = sessionStorage.getItem('current_address');
      console.log(this.address);
      var mth = "";
      var day = "";
      if (currentdate.getDate() < 9)
        day = "0" + currentdate.getDate();
      else
        day = currentdate.getDate().toString();
      if (currentdate.getMonth() < 9)
        mth = "0" + (currentdate.getMonth() + 1);
      else
        mth = (currentdate.getMonth() + 1).toString();
      var currentweekdate = currentdate.getFullYear() + "-" + mth + "-" + day;
      // console.log("currentweekdate");
      // console.log(currentweekdate);
      this.edata.getCalandarService({ leadaddress: this.address, endweekdate: currentweekdate }).subscribe(res => {
        console.log(res);
        if (res != null) {
          this.events = this.cdata.MakeEvent(res, this.actions, colors.green);
          this.calstatus.next(true);
        }
        else {
          this.router.navigate(['/calendar/googlelogin']);
        }
        this.loading = false;
        console.log("working");

      });
    }
  }







  // events: CalendarEvent[] = [{
  //   start: subDays(startOfDay(new Date()), 1),
  //   end: addDays(new Date(), 1),
  //   title: '[A 3 day event]',
  //   color: colors.red,
  //   actions: this.actions
  // }, {
  //   start: startOfDay(new Date()),
  //   title: 'An event with no end date',
  //   color: colors.yellow,
  //   actions: this.actions
  // }, {
  //   start: subDays(endOfMonth(new Date()), 3),
  //   end: addDays(endOfMonth(new Date()), 3),
  //   title: 'A long event that spans 2 months',
  //   color: colors.blue
  // }, {
  //   start: addHours(startOfDay(new Date()), 2),
  //   end: new Date(),
  //   title: 'A draggable and resizable event',
  //   color: colors.yellow,
  //   actions: this.actions,
  //   resizable: {
  //     beforeStart: true,
  //     afterEnd: true
  //   },
  //   draggable: true
  // }];


  activeDayIsOpen: boolean = true;

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  // eventTimesChanged({
  //   event,
  //   newStart,
  //   newEnd
  // }: CalendarEventTimesChangedEvent): void {
  //   event.start = newStart;
  //   event.end = newEnd;
  //   this.handleEvent('Dropped or resized', event);
  //   this.refresh.next();
  // }

  // handleEvent(action: string, event: CalendarEvent): void {
  //   this.modalData = { event, action };
  //   this.modal.open(this.modalContent, { size: 'lg' });
  // }

  // addEvent(): void {
  //   this.events.push({
  //     title: 'New event',
  //     start: startOfDay(new Date()),
  //     end: endOfDay(new Date()),
  //     color: colors.red,
  //     draggable: true,
  //     resizable: {
  //       beforeStart: true,
  //       afterEnd: true
  //     }
  //   });
  //   this.refresh.next();
  // }
}
